import { render, staticRenderFns } from "./TagPicker.vue?vue&type=template&id=05bddcd4&"
import script from "./TagPicker.vue?vue&type=script&lang=js&"
export * from "./TagPicker.vue?vue&type=script&lang=js&"
import style0 from "./TagPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports